import { render, staticRenderFns } from "./CatalogDetails.vue?vue&type=template&id=3327ba4f&scoped=true&"
import script from "./CatalogDetails.vue?vue&type=script&lang=js&"
export * from "./CatalogDetails.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDetails.vue?vue&type=style&index=0&id=3327ba4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327ba4f",
  null
  
)

export default component.exports